import { render, staticRenderFns } from "./CreditModal.vue?vue&type=template&id=024f4535&scoped=true"
import script from "./CreditModal.vue?vue&type=script&lang=ts"
export * from "./CreditModal.vue?vue&type=script&lang=ts"
import style0 from "./CreditModal.vue?vue&type=style&index=0&id=024f4535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f4535",
  null
  
)

export default component.exports